<template>
  <SeoLandingPage :page="page" />
</template>

<script setup>
import page from "#build/page-data/solutions/bookkeeping-practice-management-software.mjs";
</script>
